// extracted by mini-css-extract-plugin
export default {"article":"Info_article__Kmcgz","link":"Info_link__7dZB5","tabContainer":"Info_tabContainer__j-Ekd","articles":"Info_articles__tckQP"};